import React, { useEffect, useState } from "react";
import { getRoomDetails, getRoomDetailsByPg } from "./apiService";
import "../css/dashboard.css";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./auth";

const RoomDetails = () => {
  const [roomdetails, setRoomdetails] = useState([]);
  const navigate = useNavigate();
  const { pgid, roomId, Bcount } = useAuth();

  useEffect(() => {
    getRoomDetailsByPg(pgid).then((res) => {
      setRoomdetails(res);
      // console.log(roomdetails);
    });
  }, [pgid]);

  const handleSelect = (room) => {
    // console.log(room);
    roomId(room.id);
    navigate("GuestDetails");
  };
  const handleEdit = (room) => {
    // console.log(room);
    roomId(room.id);
    navigate("EditRoom");
  };
  const handleAddTenant = (room) => {
    // console.log(room);
    roomId(room.id);
    Bcount(room.beds);
    navigate("AddTenant");
  };
  const handleDeleteRoom = (room) => {
    // console.log(room);
    roomId(room.id);
    navigate("DeleteRoom");
  };

  return (
    <div>
      <div className="container-box">
        <h3 className="header">Room Details</h3>
        <table>
          <thead>
            <tr>
              <th>ROOM NAME</th>
              <th>BEDS</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {roomdetails.map((room) => {
              if (room.pgname === pgid) {
                return (
                  <tr key={room.id}>
                    <td>{room.roomname}</td>
                    <td>{room.beds}</td>
                    <td>
                      <button onClick={() => handleSelect(room)}>
                        GuestList
                      </button>
                      <button onClick={() => handleAddTenant(room)}>
                        AddGuest
                      </button>
                      <button onClick={() => handleEdit(room)}>
                        Edit Room
                      </button>
                      <button onClick={() => handleDeleteRoom(room)}>
                        DeleteRoom
                      </button>
                    </td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      </div>
      <Outlet />
    </div>
  );
};

export default RoomDetails;
